import React, { useState } from 'react'
import './Planes.css'
const Planes = () => {
    const [referido, setReferido] = useState(localStorage.getItem('referedCode'))
    
    const btnPruebaGratis = () =>{
        window.location.replace(`https://chatby.io/register${referido? `?ref=${referido}` :'?ref=Web'}`)
    }
  return (
    <div className="container-content">
        <div className="title-content">
          <h4 className="title-content-h4">
          Optimiza tu comunicación con la tecnología más avanzada
          </h4>
          <h3 className="title-content-h3">
          Elige la opción perfecta y disfruta de un servicio excepcional          
          </h3>
        </div>
        <div className="content-content">
          <div className="card-planes">
            <h4 className="Card-tittle">Plan Business </h4>
            <span className="Card-precio">$25</span>
            <span className="moneda-precio">USD/mes</span>
            <div className="info-plan-card">
              🔘 1 Bot Omnicanal
              <br />
              🔘 1,000 Contactos
              <br />
              🔘 5 Miembros
              <br />
              🔘 CRM
              <br />
              🔘 Soporte
              <br />
              🔘 Acceso a todas las funcionalidades <span style={{padding:'3px' , borderRadius:'8px', backgroundColor:'rgb(235, 64, 167)',color:'white',fontWeight:'bold',letterSpacing:'1px'}}>PRO</span>
              <br />
            </div>
            <div className="botones-card">
              <button className="boton-registro" onClick={btnPruebaGratis}>
                {" "}
                Prueba gratis por 14 dias
              </button>
            </div>
          </div>
          <div className="card-planes">
            <span className="span-masusado-card"></span>

            <h4 className="Card-tittle">Plan Business Lite</h4>
            <span className="Card-precio">$54 </span>
            <span className="moneda-precio">USD/mes</span>
            <div className="info-plan-card">
              🔘 1 Bot Omnicanal
              <br />
              🔘 10,000 Contactos
              <br />
              🔘 5 Miembros
              <br />
              🔘 CRM
              <br />
              🔘 Soporte Pro
              <br />
              🔘 Acceso a todas las funcionalidades <span style={{padding:'3px' , borderRadius:'8px', backgroundColor:'rgb(235, 64, 167)',color:'white',fontWeight:'bold',letterSpacing:'1px'}}>PRO</span>
              <br />
            </div>
            <div className="botones-card">
              <button className="boton-registro" onClick={btnPruebaGratis}>
                {" "}
                Prueba gratis por 14 dias
              </button>
            </div>
          </div>
          <div className="card-planes">
            <h4 className="Card-tittle">Plan Business Pro</h4>
            <span className="Card-precio">$197</span>
            <span className="moneda-precio">USD/mes</span>
            <div className="info-plan-card">
              🔘 1 Bot Omnicanal
              <br />
              🔘 50,000 Contactos
              <br />
              🔘 10 Miembros
              <br />
              🔘 CRM
              <br />
              🔘 Soporte Prioritario
              <br />
              🔘 Acceso a todas las funcionalidades <span style={{padding:'3px' , borderRadius:'8px', backgroundColor:'rgb(235, 64, 167)',color:'white',fontWeight:'bold',letterSpacing:'1px'}}>PRO</span>
              <br />
            </div>
            <div className="botones-card">
              <button className="boton-registro" onClick={btnPruebaGratis}>
                {" "}
                Prueba gratis por 14 dias
              </button>
            </div>
          </div>
        </div>
      </div>
  )
}

export default Planes
